import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { css } from 'glamor';
import Transition from 'react-transition-group';

const ZoomInAndOut = ({ children, position, ...props }) => (
    <Transition
        {...props}
        timeout={800}
        onEnter={ node => node.classList.add('zoomIn', 'animate')}
        onExit={node => {
            node.classList.remove('zoomIn', 'animate');
            node.classList.add('zoomOut', 'animate');
        }}
    >
        {children}
    </Transition>
);

class LoginNotificationSystem extends Component {

    notify (message,errorType) {

        if (! toast.isActive(this.toastId)) {
            if (errorType === 'error')
                this.toastId = toast.error(message);
            else if (errorType === 'warning')
                this.toastId = toast.warning(message);
            else if (errorType === 'info')
                this.toastId = toast.info(message);
            else if (errorType === 'success')
                this.toastId = toast.success(message);
            else if (errorType === 'default')
                this.toastId = toast.default(message);
        }

    }

    render(){
        return (
            <ToastContainer
                position="bottom-left"
                type="error"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                pauseOnHover
            />
        )
    }
}

export default LoginNotificationSystem;


// WEBPACK FOOTER //
// ./src/views/Pages/Login/LoginNotificationSystem.js